
import {
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { formatCurrency } from '@/utils/numberFormats';
import ChannelPlanExceededMixin from '@/mixins/channel-plan-exceeded';
import UserQuotaMixin from '@/mixins/user-quota';
import PlanCapabilities from './PlanCapabilities.vue';

interface PlansAndChannelsData {
  id: number;
  price: number;
  sms?: number;
  whatsapp?: number;
  email?: number;
  name?: string;
  users?: number;
  interactionz?: number;
  priceForExceededUsers?: number
  priceForExceededInteratcionz?: number;
}

interface CardData {
  title: string;
  type: 'software' | 'channel';
  currency: string;
  data: PlansAndChannelsData[];
}

@Component({
  components: {
    PlanCapabilities,
  },
})
export default class SelectPlanCard extends mixins(ChannelPlanExceededMixin, UserQuotaMixin) {
  @Prop({
    required: true,
    default: () => ({}),
    type: Object,
  }) private cardData!: CardData

  @Prop({
    required: true,
    default: () => false,
    type: Boolean,
  }) private isActive!: boolean

  @Prop({
    required: true,
    default: () => ({}),
    type: Object,
  }) private defaultSelected!: PlansAndChannelsData;

  @Prop({
    required: false,
    default: () => false,
    type: Boolean,
  }) private isInvalid!: boolean

  formatCurrency = formatCurrency;

  valueChanged(item: PlansAndChannelsData) {
    this.$emit('onRadioButtonClicked', this.cardData.type, item);
  }

  selectedItem: PlansAndChannelsData = {} as PlansAndChannelsData;

  mounted() {
    this.selectedItem = this.defaultSelected;
    this.fetchGeneralConsumption();
    this.fetchUserQuotaConsumption();
    this.$canIViewFeature({ name: 'users-quota-exceeded', options: { skipCache: true } })
      .then((isOn: boolean) => { this.showUsersQuotaExceeded = !!isOn; });
  }

  @Watch('defaultSelected', { deep: true })
  setSelectedItem() {
    this.selectedItem = this.defaultSelected;
  }

  isEnterprise(cardDataItemName: string) {
    return cardDataItemName === 'Enterprise';
  }

  public showUsersQuotaExceeded = false;

  canShowUserQuotaLimitReachedPopover(item: PlansAndChannelsData): boolean {
    return (
      this.selectedItem?.id === item.id
      && item.id === this.defaultSelected?.id
      && this.cardData?.type === 'software'
      && this.hasUserQuotaLimitReached
      && this.showUsersQuotaExceeded
    );
  }

  canShowUserQuotaExceededPopover(item: PlansAndChannelsData): boolean {
    return (
      this.selectedItem?.id === item.id
      && item.id === this.defaultSelected?.id
      && this.cardData?.type === 'software'
      && this.hasUserQuotaExceeded
      && this.showUsersQuotaExceeded
    );
  }

  canShowPopover(item: PlansAndChannelsData): boolean {
    return (
      this.selectedItem?.id === item.id
      && item.id === this.defaultSelected?.id
      && this.cardData?.type === 'channel'
      && this.hasChannelPlanExceeded
    );
  }
}
